import { Box, Typography, Button, Alert } from '@mui/material';

export default function ConfirmStep({ method, toVersion, onConfirm }) {
  return (
    <Box sx={{ textAlign: 'center', maxWidth: 440, mx: 'auto', py: 4 }}>
      <Typography variant="h6" gutterBottom>Update your sensor</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        We&apos;ll update your sensor to the latest version{toVersion ? ` (${toVersion})` : ''}. Keep the USB
        cable connected until it finishes.
      </Typography>
      {method === 'usb' && (
        <Alert severity="info" sx={{ textAlign: 'left', mb: 2 }}>
          A system popup will appear asking you to choose a device. Pick the one named
          <strong> USB Serial (CH340)</strong> and click Connect.
        </Alert>
      )}
      <Button variant="contained" size="large" onClick={onConfirm}>Update now</Button>
    </Box>
  );
}
